export default __webpack_public_path__ + "static/media/hermes_915_4.e9aae5e6.jpg";